import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "CheckBox",
  props: {
    // 复选框数据
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isShowCheck: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    title: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      checkList: [] //复选项

    };
  },
  methods: {
    trueClick: function trueClick() {
      var _this = this;

      this.$emit("setShow", false);
      var ids = [];
      this.data.forEach(function (item) {
        _this.checkList.forEach(function (i) {
          if (item.name === i) {
            ids.push(item.id);
          }
        });
      });
      this.$emit("getValue", ids, this.checkList);
    },
    selCheck: function selCheck() {
      var _this2 = this;

      var ids = [];
      this.data.forEach(function (item) {
        _this2.checkList.forEach(function (i) {
          if (item.name === i) {
            ids.push(item.id);
          }
        });
      });
      this.$emit("getValue", ids, this.checkList);
    }
  }
};